import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useAuthState } from "../context/AuthContext";
import TicketComponent from "../components/support/customerSupportTicket/TicketComponent";
import TicketHwComponent from "../components/support/HwSupportTicket/TicketHwComponent";
import { useParams } from "react-router-dom";

const NewTicketPage = () => {

    const { user } = useAuthState();
    const { param } = useParams();

    return (
        <Container className="text-start">
            <Row className="align-items-center">
                <Col xs="6">
                    <h3><span className="text-energo">ENERGO</span> Support</h3>
                    <h4 className="text-muted">Neues Ticket</h4>
                </Col>
                <Col xs="6" className="text-end">
                    {
                        user.x_is_house_management ?
                            <a href="/hw/dashboard/support/" className="btn btn-energo rounded-pill">Ticketübersicht</a>
                        :
                            <a href="/dashboard/support/" className="btn btn-energo rounded-pill">Ticketübersicht</a>
                    }
                </Col>
            </Row>

            <Row className="mt-5 justify-content-center">
                <Col xl="11">
                    {user.x_is_house_management?
                        <TicketHwComponent param={param} />
                        :
                        <TicketComponent param={param} />
                    }
                </Col>
            </Row>
        </Container>
    )
}

export default NewTicketPage;